import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Table from '../../../../shared/table';
import Button from '../../../../shared/button';

const tableColumns = ['First Name', 'Last Name', 'Email', 'Invitation Sent', 'Resend Invitation']

interface IInvitedPartnersTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    onResendLink: (token: string) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const InvitedPartnersTable = ({
    rows,
    paginationData,
    rowsLoading,
    onResendLink,
    setPaginationState,
}: IInvitedPartnersTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.firstName}</td>
                                <td className='px-6 py-4'>{row?.lastName}</td>
                                <td className='px-6 py-4'>{row?.email}</td>
                                <td className='px-6 py-4'>{moment(row?.updatedAt || row?.createdAt || '')?.format('DD/MM/YYYY')}</td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <Button
                                        label={'Resend Invitation'}
                                        className={row?.used ? 'btn-primary-rounded-less-disable' : 'btn-primary-rounded-less'}
                                        onClickButton={() => !row?.used && onResendLink(row?.token)}
                                    />
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default InvitedPartnersTable;